import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('expense_report_details'),
    sectionDetailsTitle: defineMessage('expense_report_details'),
    sectionExpensesTitle: defineMessage('expenses'),
    fieldTransactionNumber: defineMessage('exp_rept'),
    fieldEmployee: defineMessage('employee'),
    fieldExchangeRate: defineMessage('exchange_rate_1'),
    fieldAdvance: defineMessage('advance'),
    fieldPurpose: defineMessage('purpose'),
    fieldTransactionDate: defineMessage('date'),
    fieldDueDate: defineMessage('due_date_1'),
    fieldPostingPeriod: defineMessage('posting_period_1'),
    fieldDepartment: defineMessage('department'),
    fieldClass: defineMessage('class'),
    fieldLocation: defineMessage('location'),
    fieldAccountForCorporateCardExpenses: defineMessage('account_for_corporate_card_expenses'),
    errorRefLineNumbersNotUnique: defineMessage('line_reference_numbers_should_be_unique'),
    errorRequiredFields: defineMessage('please_fill_all_mandatory_fields'),
    errorExpenseLineTaxAmountExceed: defineMessage('expense_line_tax_amount_n_maxdigitscount_digits'),
    errorTotalReimbursableAmountLessZero: defineMessage('total_reimbursable_amount_cannot_be_negative'),
    errorTotalExpensesLessZero: defineMessage('total_expenses_cannot_be_negative'),
    errorAdvanceToApplyLessZero: defineMessage('advance_to_apply_cannot_be_negative'),
    errorMemoMoreThanLimit: defineMessage('purpose_cannot_contain__han_maxcharscount_chars'),
    errorCorporateCardMandatory: defineMessage('please_select_an_account_for_corporate_card'),
    errorExchangeRate: defineMessage('exchange_rate_is_missin_er_manual_exchange_rate'),
};
